import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const CaseStudies = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <g clipPath="url(#clip0_6988_471)">
          <path
            d="M4.3125 28.25C8.95961 32.4517 22.125 31.1875 26.5625 24.3125C22.8817 23.4807 8.93002 26.8121 4.3125 28.25Z"
            fill="#2B2F38"
          />
          <path
            d="M29.75 6.3396C26.25 6.75 14 6.3396 10.4385 6.3396C10.4385 11.1876 10 24.5001 3.75 27.0625C5.375 29.5001 14.875 32.5 17.6875 27.4375C26.875 28.125 28.5625 21.125 29.75 6.3396Z"
            fill="#FFDB59"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.6885 3.02698C24.5625 3.4375 13.75 3.375 10.4385 3.02698C10.4385 7.87498 9.625 22.125 3.1875 22.75C4.5 25.8125 13.8125 29.375 16.625 24.3125C26.75 25.6875 26.001 14.807 27.6885 3.02698Z"
            fill="#FFDB59"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="17.84" cy="16.4693" r="9.1484" fill="white" stroke="#2B2F38" strokeWidth="1.4" />
          <path
            d="M27.5654 29.3267L21.6133 24.2306C21.3536 24.0083 21.3467 23.609 21.5986 23.3778L23.955 21.2151C24.2364 20.9568 24.6819 21.0107 24.8936 21.3287L29.2335 27.849C29.5331 28.2991 29.47 28.8987 29.0834 29.2766C28.6667 29.6839 28.008 29.7057 27.5654 29.3267Z"
            fill="#BEE9FC"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
          <circle cx="17.1516" cy="15.6879" r="9.1484" fill="#BEE9FC" stroke="#2B2F38" strokeWidth="1.4" />
          <path d="M21.0228 16.0547L13.2407 16.0547" stroke="#2B2F38" strokeWidth="1.4" strokeLinecap="round" />
          <path d="M17.1516 18.8171H13.2628" stroke="#2B2F38" strokeWidth="1.4" strokeLinecap="round" />
          <path d="M21.0625 13.4297H13.2407" stroke="#2B2F38" strokeWidth="1.4" strokeLinecap="round" />
        </g>
        <defs>
          <clipPath id="clip0_6988_471">
            <rect width="32" height="32" fill="white" transform="translate(0 0.123413)" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

export default CaseStudies
